<div class="dash">
    <div class="row">
        <div class="col-12 ml-auto mr-auto">
            <div class="dash-card no-padding">
                <div class="dash-card-header d-block"
                    style="flex-direction: column;">
                    <div class="row no-gutters">
                        <div class="col-12">
                            <h2>Templates de minutas</h2>
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div
                            class="col-12 d-flex justify-content-end mt-3 px-0">
                            <app-button
                                *ngIf="hasFilters && permissionObj.canFilter"
                                [danger]="true" [outline]="true" class="mr-2"
                                (onClick)="resetForm()"
                                [disabled]="loadingDrafts">
                                <svg-icon src="assets/images/icon-times.svg"
                                    class="filter-clear-icon"></svg-icon>
                                Limpar filtros
                            </app-button>

                            <app-button (onClick)="toggleFilterModal()"
                                [inverted]="true" class="add-button mr-2"
                                *ngIf="permissionObj.canFilter"
                                [disabled]="loadingDrafts">
                                <svg-icon src="assets/images/icon_filter.svg"
                                    class="mr-2"></svg-icon>
                                {{ hasFilters ? 'Editar filtros' : 'Filtrar
                                listagem' }}
                            </app-button>

                            <app-button (onClick)="redirectToForm()"
                                class="add-button" *ngIf="permissionObj.canAdd">
                                <svg-icon src="assets/images/icon-add.svg"
                                    class="mr-2"></svg-icon>
                                Adicionar minuta
                            </app-button>
                        </div>
                    </div>

                    <div class="col-12 mt-3 px-0"
                        *ngIf="!loadingDrafts && hasFilters && appliedFilters.length > 0">
                        <div
                            class="d-flex flex-wrap align-items-center justify-content-end">
                            <app-filter-tag
                                *ngFor="let filter of appliedFilters"
                                [label]="filter.label" [value]="filter.value">
                            </app-filter-tag>
                        </div>
                    </div>
                </div>

                <ng-container
                    *ngIf="!loadingDrafts && drafts.length === 0 && !hasFilters">
                    <app-empty-content [isVisible]="true" [large]="true"
                        title="Não há nenhum template de minuta para exibir"
                        description="Não há templates de minutas para serem exibidos no momento, para adicionar um novo template clique no botão abaixo."
                        icon="/assets/images/figure_3d_search.png"
                        (onClick)="redirectToForm()" [haveButtonIcon]="true"
                        buttonLabel="Adicionar minuta">
                    </app-empty-content>
                </ng-container>

                <ng-container
                    *ngIf="!loadingDrafts && drafts.length === 0 && hasFilters">
                    <app-empty-content [isVisible]="true" [large]="true"
                        title="Nenhum resultado encontrado"
                        description="Não foram encontrados templates de minutas com os filtros aplicados. Tente ajustar os filtros para ver mais resultados."
                        icon="/assets/images/figure_3d_search.png">
                    </app-empty-content>
                </ng-container>

                <div class="dash-card-body  padding-container">
                    <div clsas="styled-scroll">
                        <ng-container *ngIf="loadingDrafts">
                            <table #table>
                                <thead>
                                    <tr>
                                        <th>
                                            <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                            </ngx-skeleton-loader>
                                        </th>

                                        <th>
                                            <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                            </ngx-skeleton-loader>
                                        </th>

                                        <th>
                                            <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                            </ngx-skeleton-loader>
                                        </th>

                                        <th>
                                            <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                            </ngx-skeleton-loader>
                                        </th>

                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                                        <td>
                                            <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '200px',
                                        marginBottom:'0'
                                          }">
                                            </ngx-skeleton-loader>
                                        </td>
                                        <td>
                                            <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                            </ngx-skeleton-loader>
                                        </td>
                                        <td>
                                            <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                            </ngx-skeleton-loader>
                                        </td>
                                        <td>
                                            <ngx-skeleton-loader [theme]="{
                                            height: '24px',
                                            width: '80px',
                                        marginBottom:'0'
                                          }">
                                            </ngx-skeleton-loader>
                                        </td>
                                        <td>
                                            <div
                                                class="d-flex align-items-center justify-content-end">
                                                <ngx-skeleton-loader [theme]="{
                                            height: '32px',
                                            width: '32px',
                                            marginRight: '8px',
                                            marginBottom:'0'
                                          }">
                                                </ngx-skeleton-loader>
                                                <ngx-skeleton-loader [theme]="{
                                            height: '32px',
                                            width: '32px',
                                            marginBottom:'0'
                                          }">
                                                </ngx-skeleton-loader>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>

                        <table class="bordered"
                            *ngIf="!loadingDrafts && drafts.length > 0">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Criado em</th>
                                    <th>Última atualização</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let draft of drafts">
                                    <td>
                                        {{draft.name}}
                                    </td>
                                    <td>
                                        {{draft.initial_date | date:
                                        'dd/MM/yyyy'}}
                                    </td>
                                    <td>
                                        {{draft.updated_at | date:
                                        'dd/MM/yyyy'}}
                                    </td>


                                    <td>
                                        <div class="status-tag"
                                            *ngIf="!draft.is_draft"
                                            [class.-inactive]="!draft.enabled">
                                            {{draft.enabled ? 'Ativado' :
                                            renderDisabledStatus(draft)}}
                                        </div>

                                        <div class="status-tag draft"
                                            *ngIf="draft.is_draft">
                                            Rascunho
                                        </div>
                                    </td>
                                    <td>
                                        <div class="dash-card-item-buttons">
                                            <app-tooltip text="Editar"
                                                position="top"
                                                *ngIf="permissionObj.canEdit">
                                                <button class="dash-item-button"
                                                    (click)="redirectToForm(draft.id)">
                                                    <svg-icon
                                                        src="assets/images/icon-edit.svg"></svg-icon>
                                                </button>
                                            </app-tooltip>
                                            <app-spacer [right]="16"
                                                *ngIf="!draft.is_draft"></app-spacer>

                                            <ng-container
                                                *ngIf="!draft.is_draft">
                                                <app-tooltip text="Inativar"
                                                    position="top"
                                                    *ngIf="permissionObj.canChange && !draft.error && draft.enabled">
                                                    <button
                                                        class="dash-item-button"
                                                        (click)="toggleDraftStatus(draft.id)">
                                                        <svg-icon
                                                            src="assets/images/icon-ban.svg"></svg-icon>
                                                    </button>
                                                </app-tooltip>
                                                <app-tooltip text="Ativar"
                                                    position="top"
                                                    *ngIf="permissionObj.canChange && !draft.error && !draft.enabled">
                                                    <button
                                                        class="dash-item-button"
                                                        (click)="toggleDraftStatus(draft.id)">
                                                        <svg-icon
                                                            src="assets/images/icon-check.svg"></svg-icon>
                                                    </button>
                                                </app-tooltip>
                                                <ng-container
                                                    *ngIf="draft.error">
                                                    <app-spacer
                                                        [right]="16"></app-spacer>
                                                    <app-tooltip
                                                        text="Visualizar"
                                                        position="top">
                                                        <button
                                                            class="dash-item-button"
                                                            (click)="openWarningModal(draft.id)">
                                                            <svg-icon
                                                                src="assets/images/icon-eye.svg"></svg-icon>
                                                        </button>
                                                    </app-tooltip>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </td>
                                </tr>


                            </tbody>
                            <app-spacer [bottom]="28"></app-spacer>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 ml-auto mr-auto"
            *ngIf="!loadingDrafts && drafts.length > 0">
            <div class="dash-card-pagination">
                <app-pagination [data]="drafts" [count]="count"
                    [show]="!loadingDrafts" [offset]="offset"
                    (onPageChange)="changePageData($event)"
                    [dashPagination]="true" [resultsPerPage]="results_per_page">
                </app-pagination>
            </div>
        </div>
    </div>
</div>

<app-warning-modal [active]="warningModal" (onClose)="closeWarningModal()"
    size="lg">
    <h3>Variáveis inativas detectadas</h3>
    <app-spacer [bottom]="24"></app-spacer>
    <p>Foram identificadas variáveis inativas que impedem a geração correta do
        documento. Para corrigir o erro, você será redirecionado ao dicionário
        de variáveis, onde poderá ativá-las. Deseja prosseguir?</p>

    <p class="missing-variables mt-3">Variáveis inativas em {{selectedDraft}}
    </p>

    <div class="d-flex flex-wrap mt-3" *ngIf="!loadingVariables">
        <ng-container *ngFor="let errorVariable of errorVariables">
            <div class="tag mb-2">
                {{errorVariable.variable}}
            </div>
            <app-spacer [right]="8"></app-spacer>
        </ng-container>
    </div>

    <ng-container *ngIf="loadingVariables">
        <ngx-skeleton-loader [theme]="{
            width: '100%',
            height: '30px',
            marginBottom: '8px'
          }">
        </ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{
            width: '100%',
            height: '30px',
            marginBottom: '8px'
          }">
        </ngx-skeleton-loader>
    </ng-container>

    <app-spacer [bottom]="56"></app-spacer>

    <app-button (onClick)="closeWarningModal()" [center]="true" [danger]="true">
        Cancelar
    </app-button>
    <app-spacer [bottom]="8"></app-spacer>
    <app-button
        (onClick)="canViewVariables ? redirectToVariables() : closeWarningModal()"
        [center]="true" class="add-button">
        {{canViewVariables ? 'Avançar' : 'Fechar'}}
    </app-button>
</app-warning-modal>


<app-side-modal [active]="showFilterModal" title="Filtrar listagem"
    (onClose)="toggleFilterModal()">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-12">
                <app-input [group]="form" controlName="name"
                    label="Nome da minuta" placeholder="Digite">
                </app-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>
        </div>

        <div class="row">

            <div class="col-12 col-lg-8">
                <app-select [items]="typeItems" [group]="form"
                    controlName="type" label="Tipo de minuta"
                    placeholder="Selecione">
                </app-select>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 col-lg-4">
                <app-select [items]="statusItems" [group]="form"
                    controlName="enabled" label="Status"
                    placeholder="Selecione">
                </app-select>
                <app-spacer [bottom]="16"></app-spacer>
            </div>
        </div>


        <div class="row">
            <div class="col-12 col-lg-6">

                <app-masked-input [group]="form" controlName="initial_date"
                    mask="00/00/0000" label="Início da vigência"
                    placeholder="dd/mm/aaaa">
                </app-masked-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 col-lg-6">
                <app-masked-input [group]="form" controlName="final_date"
                    mask="00/00/0000" label="Fim da vigência"
                    placeholder="dd/mm/aaaa">
                </app-masked-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <app-select [items]="applicableItems" [multiple]="true"
                    [group]="form" controlName="roles"
                    label="Aplicável aos papeis" placeholder="Selecione">
                </app-select>
                <app-spacer [bottom]="16"></app-spacer>
            </div>


            <ng-container *ngIf="verifyIdIsApplicable('roles', 'provider')">
                <div class="col-12">
                    <app-select [items]="agentItems" [group]="form"
                        [multiple]="true" controlName="agents"
                        label="Aplicável aos prestadores"
                        placeholder="Selecione">
                    </app-select>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </ng-container>

            <ng-container *ngIf="verifyIdIsApplicable('roles', 'assignor')">
                <div class="col-12 col-lg-4">
                    <app-select [items]="coobligationItems" [group]="form"
                        controlName="coobligation" label="Coobrigação"
                        placeholder="Selecione">
                    </app-select>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </ng-container>
        </div>

        <app-spacer [bottom]="32"></app-spacer>

        <div class="row button-sticky">
            <div class="col-12 col-lg-6">
                <app-button (onClick)="resetForm()" class="add-button"
                    [phantom]="true">
                    Limpar filtros
                </app-button>
            </div>

            <div class="col-12 col-lg-6">
                <div class="text-right">
                    <app-button (onClick)="submitForm()" class="add-button"
                        [disabled]="!canApplyFilters || loadingDrafts">
                        Aplicar filtros
                    </app-button>
                </div>
            </div>
        </div>

    </form>
</app-side-modal>

<!-- Carbon Warning Modal para mudança de status -->
<app-carbon-warning-modal [active]="showStatusModal" [title]="getModalTitle()"
    [message]="getModalMessage()" [confirmText]="getConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmStatusChange.bind(this)"
    [cancelAction]="closeStatusModal.bind(this)" (onClose)="closeStatusModal()">
</app-carbon-warning-modal>